
const authoring = [

  {
    id: "0",
    name: 'Animate',
    level: 'Expert'
  },
  {
    id: "1",
    name: 'Photoshop',
    level: 'Advanced'
  },
  {
    id: "2",
    name: 'Illustrator',
    level: 'Experienced'
  },
  {
    id: "3",
    name: 'MailChip',
    level: 'Familiar'
  },
  {
    id: "4",
    name: 'HotSpot',
    level: 'Familiar'
  },
  {
    id: "5",
    name: 'Braze',
    level: 'Familiar'
  },
  {
    id: "6",
    name: 'HTML5 Banners',
    level: 'Expert'
  },
  {
    id: "7",
    name: 'Figma',
    level: 'Familiar'
  },

];

export default authoring;